import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {Subscription} from "rxjs/Subscription";
import {LanguageService} from "../../../shared/services/language/language.service";

declare const $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {


    private languageSubscripton: Subscription;
    public currentLanguage = 'en';

    constructor(private layoutService: LayoutService,
                private languageService: LanguageService) {
        this.layoutService.setTitle('Home')
    }

    ngOnInit() {
        this.subscribeLanguageEvents();

    }


    ngAfterViewInit(): void {
        console.log("after view init");
        setTimeout(this.queueAnimations, 500);
    }


    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();
    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }

    scrollToServices = () => {
        $("html, body").stop().animate({scrollTop: $('#projectDesign').offset().top}, 500, 'swing');
    };

    queueAnimations = () => {
        $('#whyUsGrid').visibility({
            throttle: 150,
            onTopVisible: function () {
                // loads a max of 5 times
                console.log("hohoho");
                $('#whyUsGrid').children('.column')
                    .transition({
                        animation: 'fade up',
                        duration: 800,
                        interval: 200
                    });
            }
        });

        $('#parallaxContent').visibility({
            includeMargin: true,
            onTopVisible: function () {
                $('#parallaxContent').find('div.hidden')
                    .transition({
                        animation: 'fade in',
                        duration: 800,
                    });
            }
        });

    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/home/home.component.ts